import { GENERIC_FAILURE } from '../config/text/text';
import { getGift } from '../services/gifting';

export const GiftOptionType = {
  download: 'download',
  eVoucher: 'eVoucher',
  giftPack: 'giftPack',
};

export const sendGift = async ({ values, voucher, giftOptionType = null }) => {
  const data = {
    giftEmail: values.email || null,
    giftMessage: values.message || null,
    giftOptionType,
    orderLineId: voucher.orderLineId || '',
    recipientAddressLine1: values.addressLine1 || null,
    recipientAddressLine2: values.addressLine2 || null,
    recipientCity: values.city || null,
    recipientName: values.name,
    recipientPostCode: values.postCode || null,
    senderName: values.senderName,
    voucherCode: voucher.voucherCode,
  };

  try {
    const response = await getGift(data);

    if (response.result === 'SUCCESS') {
      return response;
    } else {
      throw new Error(GENERIC_FAILURE);
    }
  } catch {
    // we should log the error message
    throw new Error(GENERIC_FAILURE);
  }
};
